import React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

import { AI_COLORS } from '../aiAnalyticsConstants';

export default function InlineProgress({ label, dense = false }) {
  return (
    <Box sx={{ width: '100%', minWidth: 0, my: dense ? 0.5 : 1 }}>
      <Typography
        variant={dense ? 'caption' : 'body2'}
        color={dense ? 'text.secondary' : 'text.primary'}
        sx={{ display: 'block', mb: 0.5, ...(dense ? {} : { fontWeight: 600 }) }}
      >
        {label}
      </Typography>
      <LinearProgress
        sx={{
          height: dense ? 3 : 5,
          borderRadius: 2,
          backgroundColor: AI_COLORS.brandSurface,
          '& .MuiLinearProgress-bar': { backgroundColor: AI_COLORS.brand }
        }}
      />
    </Box>
  );
}
